<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 1V3H20C21.1046 3 22 3.89543 22 5V7H2V5C2 3.89543 2.89543 3 4 3H6V1H8V3H16V1H18Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 9V21C2 22.1046 2.89543 23 4 23H20C21.1046 23 22 22.1046 22 21V9H2ZM15.2821 10.8039C15.6666 10.4074 16.2997 10.3976 16.6961 10.7821C17.0621 11.137 17.0986 11.7037 16.7996 12.1007L16.7179 12.1961L10.1481 18.9713L7.25094 15.6956C6.88505 15.2819 6.9238 14.6499 7.3375 14.284C7.71937 13.9463 8.28724 13.9533 8.66012 14.2818L8.74906 14.3706L10.215 16.028L15.2821 10.8039Z"
      fill="#05070F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BookingsIconFilled',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
